import React from 'react';
import PropTypes from 'prop-types';

export default class SkipNavLink extends React.PureComponent {
    static propTypes = {
        /** The id of the target container */
        id: PropTypes.string,

        /** If true, focus will be set on the h1 inside SkipNavContain, and not
         * the container itself */
        shouldFocusOnHeading: PropTypes.bool,

        /** The contents of the link */
        children: PropTypes.node
    };

    static defaultProps = {
        id: 'page-content',
        children: 'Skip to main content',
        shouldFocusOnHeading: false
    };

    handleClick = () => {
        const { id, shouldFocusOnHeading } = this.props;

        const content = document.getElementById(id);

        if (!content) {
            return;
        }

        if (shouldFocusOnHeading) {
            const heading = content.querySelector('h1');

            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.style.outline = 'none';

                if (heading.focus) {
                    setTimeout(() => {
                        heading.focus();
                    }, 0);

                    return;
                }
            }
        }

        if (content.focus) {
            setTimeout(() => {
                content.focus();
            }, 0);
        }
    }

    render() {
        const {
            id,
            children,
            shouldFocusOnHeading,
            ...rest
        } = this.props;

        return (
            <a
                data-component="SkipNavLink"
                href={`#${id}`}
                className="skip-navigation"
                onClick={this.handleClick}
                {...rest}>
                {children}
            </a>
        );
    }
}